import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CanonicalBillSummary } from '../../../services/orders/orders.service';

@Component({
  selector: 'app-order-bill-summary',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  template: `
    <div class="space-y-3 text-sm">
      <div class="flex justify-between">
        <span class="opacity-55">Subtotal</span>
        <span class="font-black">Rs {{ canonicalBill?.merchandise?.fulfilled | number:'1.0-0' }}</span>
      </div>
      
      @if (canonicalBill?.discounts?.order_discount) {
        <div class="flex justify-between">
          <span class="opacity-55">Discount</span>
          <span class="font-black text-success">- Rs {{ canonicalBill?.discounts?.order_discount | number:'1.0-0' }}</span>
        </div>
      }
      
      <div class="flex justify-between">
        <span class="opacity-55">Delivery fee</span>
        <span class="font-black">Rs {{ canonicalBill?.fees?.delivery?.original | number:'1.0-0' }}</span>
      </div>
      
      @if (canonicalBill?.fees?.delivery?.waiver) {
        <div class="flex justify-between">
          <span class="opacity-55">Delivery discount</span>
          <span class="font-black text-success">- Rs {{ canonicalBill?.fees?.delivery?.waiver | number:'1.0-0' }}</span>
        </div>
      }
      
      <div class="flex justify-between">
        <span class="opacity-55">Packaging fee</span>
        <span class="font-black">Rs {{ canonicalBill?.fees?.packaging | number:'1.0-0' }}</span>
      </div>
      
      @if (canonicalBill?.fees?.platform) {
        <div class="flex justify-between">
          <span class="opacity-55">Platform fee</span>
          <span class="font-black">Rs {{ canonicalBill?.fees?.platform | number:'1.0-0' }}</span>
        </div>
      }
      
      @if (canonicalBill?.fees?.small_order) {
        <div class="flex justify-between">
          <span class="opacity-55">Small order fee</span>
          <span class="font-black">Rs {{ canonicalBill?.fees?.small_order | number:'1.0-0' }}</span>
        </div>
      }
      
      @if (canonicalBill?.discounts?.coins) {
        <div class="flex justify-between">
          <span class="opacity-55">Coins used</span>
          <span class="font-black text-success">- Rs {{ canonicalBill?.discounts?.coins | number:'1.0-0' }}</span>
        </div>
      }
      
      <div class="divider my-1"></div>
      
      <div class="flex justify-between text-xl font-black">
        <span class="opacity-45">Payable</span>
        <span class="text-primary">Rs {{ canonicalBill?.current_payable | number:'1.0-0' }}</span>
      </div>
      
      @if (canonicalBill?.savings?.mrp_reliable && (canonicalBill?.savings?.mrp || 0) > 0) {
        <div class="mt-2 rounded-xl border border-success/20 bg-success/5 p-3 text-center">
          <p class="text-[10px] font-black text-success tracking-wider uppercase">Savings on MRP  Rs {{ canonicalBill?.savings?.mrp | number:'1.0-0' }}</p>
        </div>
      }

      @if ((canonicalBill?.merchandise?.removed || 0) > 0) {
        <div class="mt-2 rounded-xl border border-warning/20 bg-warning/5 p-3">
           <p class="text-[10px] font-black uppercase tracking-widest text-warning mb-1">Fulfillment Adjustment</p>
           <div class="flex justify-between text-xs">
             <span class="opacity-60 font-bold">Removed Items Total</span>
             <span class="font-black">Rs {{ canonicalBill?.merchandise?.removed | number:'1.0-0' }}</span>
           </div>
        </div>
      }
    </div>
  `
})
export class OrderBillSummaryComponent {
  @Input() canonicalBill!: CanonicalBillSummary | null | undefined;
  @Input() mode: 'compact' | 'full' = 'full';
}
